module.exports = {"230781100":"铁力镇","230781101":"双丰镇","230781102":"桃山镇","230781104":"朗乡镇","230781200":"年丰乡","230781201":"工农乡","230781202":"王杨乡","230781400":"铁力林业局","230781401":"双丰林业局","230781402":"桃山林业局","230781403":"朗乡林业局","230781500":"铁力农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230781.json
// module id = 699
// module chunks = 0